export class HostLinkSelectorAPI {
    constructor(ps) {
        this.ps = ps;
    }
    async selectLink(dataItemKey, context) {
        const link = context.data[dataItemKey];
        const linkType = context.dataDefinitions[dataItemKey]?.link?.linkTypes;
        return this.ps.hostAPI.editor.selectLink(link?.value, {
            linkType,
        });
    }
}
//# sourceMappingURL=HostLinkSelectorAPI.js.map